import ApiConstant from "../../constants/api.constants";
import api from "../api";
import { ProductCheckoutProceedModel, OpenOrderSearchDTO } from "../../models/products/product-checkout-proceed-model";
import {
  MapOrderData,
  AdminMapOrderData,
} from "../../models/orders/order-mapper-model";

const tenantGuid = process.env.REACT_APP_TENAT_ID;

const setCustomerOrder = async (order: ProductCheckoutProceedModel) => {
  try {
    let data = MapOrderData(order);
    return await api
      .post(ApiConstant.setCustomerOrder, data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in customer placing order");
  }
};

const setAdminCustomerOrder = async (
  order: ProductCheckoutProceedModel,
  selectedAdminUserId: number
) => {
  try {
    let data = AdminMapOrderData(order, selectedAdminUserId);
    return await api
      .post(ApiConstant.setAdminCustomerOrder, data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in customer placing order");
  }
};

const setOrderDeliveryDate = async (orderID: any, expectedDeliveryDate: any) => {
  try {
    const response = await api.put(ApiConstant.changeOrderDeliveryDate, {
      orderID,
      expectedDeliveryDate,
    }, {
      headers: {
        "content-type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in customer placing order:", error);
    throw error; // Optional: Rethrow error to be handled elsewhere
  }
};

const updatePendingQuantityOfOrderDetail = async (
  orderDetailID: number,
  quantity: number,
  pendingQuantity: number
) => {
  const pendingQuantityUpadate: {
    orderDetailID: number,
    quantity: number,
    pendingQuantity: number
  } = { orderDetailID: orderDetailID, quantity: quantity, pendingQuantity: pendingQuantity };
  try {
    return await api
      .put(ApiConstant.updatePendingQuantity, pendingQuantityUpadate, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in pending quantity update");
  }
};

const setOrderFromCustomer = async (
  order: ProductCheckoutProceedModel,
) => {
  try {
    let data = MapOrderData(order);
    return await api
      .post(ApiConstant.createOrderFormCustomer, data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in customer placing order");
  }
};

const setOrderForCustomer = async (
  order: ProductCheckoutProceedModel,
  selectedAdminUserId: number
) => {
  try {
    let data = AdminMapOrderData(order, selectedAdminUserId);
    return await api
      .post(ApiConstant.createOrderForCustomer, data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in customer placing order");
  }
};

export const searchOrdersById = async (searchOrderId: number) => {
  try {
    const response = await api.post(ApiConstant.searchorders, {
      searchOrderId: searchOrderId,
    }, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error searching orders:", error);
    throw error;
  }
}

export const getOpenOrderUserAddresses = async (request: OpenOrderSearchDTO) => {
  try {
    const response = await api.post(ApiConstant.getOpenOrderUserAddresses, request, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; // This will be { totalRecords, addresses }
  } catch (error) {
    console.error("Error fetching open order user addresses:", error);
    throw error;
  }
};

export const getOnlinePaymenttransactionStatus = async (plutusTransactionReferenceId: number) => {
  try {
    const response = await api.get(ApiConstant.getOnlinePaymenttransactionStatus + plutusTransactionReferenceId, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response; // This will be { totalRecords, addresses }
  } catch (error) {
    console.error("Error fetching open order user addresses:", error);
    throw error;
  }
};

export const cancelOnlineTransaction = async (plutusTransactionReferenceId: number) => {
  try {
    const response = await api.post(ApiConstant.cancelOnlineTransaction, {
      plutusTransactionReferenceId,
    }, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error canceling transaction:", error);
    throw error;
  }
};

export const checkCardAndUpiEligibility = async (userId?: number) => {
  try {
    const url = userId && userId > 0
      ? `${ApiConstant.checkCardAndUpiEligibility}?userId=${userId}`
      : ApiConstant.checkCardAndUpiEligibility;
    const response = await api.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error checking Card and UPI eligibility:", error);
    throw error;
  }
};

export interface ComplaintSummaryRequest {
  pageNumber: number;
  pageSize: number;
  complaintTypeId?: number | null;
  statusId?: number | null;
  priority?: string | null;
  customerId?: number | null;
  createdBy?: number | null;
  createdOnFrom?: string | null;
  createdOnTo?: string | null;
  sortBy?: string | null;
  sortOrder?: string | null;
  filterByHighInvoice?: boolean | null;
  filterByOneWeekDelay?: boolean | null;
  filterByValueAtRisk?: boolean | null;
}

export interface ComplaintSummaryItem {
  complaintId: number;
  complaintType: string;
  status: string;
  priority: string;
  customer: string | null;
  createdBy: string;
  createdOn: string;
  lastModifiedOn: string;
  lastModifiedBy: string;
  costPerQtyInRs: number | null;
  phonenumber: string | null;
  moreThanOneWeek: boolean;
  invoiceGreaterValue: boolean;
  daysOpen: number | null;
  invoiceValue: number | null;
}

export interface ComplaintSummaryResponse {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  complaints: ComplaintSummaryItem[];
  totalHighInvoiceCount?: number;
  totalOneWeekDelayCount?: number;
  totalCostPerQtyInRs?: number;
  complaintCostInPercentage?: number;
}

export const getComplaintSummary = async (request: ComplaintSummaryRequest): Promise<ComplaintSummaryResponse> => {
  try {
    const response = await api.post(ApiConstant.getcomplaintSummary, request, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching complaint summary:", error);
    throw error;
  }
};

export interface ComplaintAlertCounts {
  highInvoiceCount: number;
  oneWeekDelayCount: number;
  newComplaintsCount: number;
  inProgressCount: number;
  valueAtRiskCount: number;
}

export const getComplaintAlertCounts = async (): Promise<ComplaintAlertCounts> => {
  try {
    const response = await api.get(ApiConstant.getComplaintAlertCounts);
    return response.data;
  } catch (error) {
    console.error("Error fetching complaint alert counts:", error);
    throw error;
  }
};


// Complaint Quick View Interfaces
export interface ComplaintProductDetail {
  id: number;
  complaintId: number;
  customerId: number;
  customerName: string;
  invoiceId: number;
  invoiceNo: number;
  // orderDetailId: number;
  productName: string;
}

export interface ComplaintServiceDetail {
  id: number;
  complaintId: number;
  customerId: number;
  customerName: string;
  serviceType: string;
  serviceDescription: string;
}

export interface ComplaintAction {
  id: number;
  complaintId: number;
  actionDescription: string;
  actionDate: string;
  actionBy: number;
  actionByName: string;
}

export interface ComplaintAttachment {
  id: number;
  complaintId: number;
  fileName: string;
  fileUrl: string;
  uploadedDate: string;
}

export interface ComplaintQuickViewResponse {
  id: number;
  complaintTypeId: number;
  complaintTypeName: string;
  description: string;
  priority: string;
  remarks: string | null;
  statusId: number;
  statusName: string;
  actionDescription: string | null;
  correctiveAction: string | null;
  preventiveAction: string | null;
  actionDate: string | null;
  actionBy: number | null;
  actionByName: string | null;
  actionByPhonenumber: string | null;
  costPerQtyInRs: number | null;
  createdBy: number;
  createdByName: string;
  createdDate: string;
  modifiedBy: number;
  modifiedByName: string;
  modifiedDate: string;
  productDetail: ComplaintProductDetail | null;
  serviceDetail: ComplaintServiceDetail | null;
  attachments: ComplaintAttachment[];
  actions: ComplaintAction[];
}

export const getComplaintQuickView = async (complaintId: number): Promise<ComplaintQuickViewResponse> => {
  try {
    const response = await api.get(`${ApiConstant.getcomplaintsquickview}${complaintId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching complaint quick view:", error);
    throw error;
  }
};

// Update Complaint Interface
export interface UpdateComplaintRequest {
  id: number;
  complaintTypeId: number;
  description: string;
  priority: string;
  statusId: number;
  actionDescription?: string;
  correctiveAction?: string;
  preventiveAction?: string;
  actionDate?: string;
  actionBy?: number;
  costPerQtyInRs?: number;
  customerId?: number;
  invoiceId?: number;
  orderDetailId?: number;
  attachments?: File[];
}

export const updateComplaint = async (request: UpdateComplaintRequest): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append('Id', request.id.toString());
    formData.append('ComplaintTypeId', request.complaintTypeId.toString());
    formData.append('Description', request.description);
    formData.append('Priority', request.priority);
    formData.append('StatusId', request.statusId.toString());
    formData.append('Remarks', '');
    formData.append('ContainerType', '');

    console.log('Required fields added to FormData');

    // Append optional fields
    if (request.actionDescription) formData.append('ActionDescription', request.actionDescription);
    if (request.correctiveAction) formData.append('CorrectiveAction', request.correctiveAction);
    if (request.preventiveAction) formData.append('PreventiveAction', request.preventiveAction);
    if (request.actionDate) formData.append('ActionDate', request.actionDate);
    if (request.actionBy) formData.append('ActionBy', request.actionBy.toString());
    if (request.costPerQtyInRs) formData.append('CostPerQtyInRs', request.costPerQtyInRs.toString());
    if (request.customerId) formData.append('CustomerId', request.customerId.toString());
    if (request.invoiceId) formData.append('InvoiceId', request.invoiceId.toString());
    if (request.orderDetailId) formData.append('OrderDetailId', request.orderDetailId.toString());

    console.log('Optional fields added to FormData');

    // Append files
    if (request.attachments && request.attachments.length > 0) {
      console.log('Adding attachments:', request.attachments.length);
      request.attachments.forEach((file, index) => {
        formData.append('Attachments', file);
        console.log(`Attachment ${index}:`, file.name, file.size);
      });
    }


    console.log('Calling API:', ApiConstant.updatecomplaintbyid);

    // Axios interceptor automatically handles Content-Type for FormData
    const response = await api.put(ApiConstant.updatecomplaintbyid, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

    console.log('API Response:', response);
    return response.data;
  } catch (error: any) {
    console.error("=== SERVICE ERROR ===");
    console.error("Error updating complaint:", error);
    console.error("Error response:", error.response);
    console.error("Error data:", error.response?.data);
    throw error;
  }
};
 

 const getUserRewardBalance = async (userId: number) => {
  const response = await api.get(
    `${ApiConstant.GetUserRewardBalance}/${userId}`
  );
  return response.data; 
};

const OrderService = {
  setCustomerOrder,
  setAdminCustomerOrder,
  setOrderDeliveryDate,
  updatePendingQuantityOfOrderDetail,
  setOrderFromCustomer,
  setOrderForCustomer,
  searchOrdersById,
  getOpenOrderUserAddresses,
  getOnlinePaymenttransactionStatus,
  cancelOnlineTransaction,
  checkCardAndUpiEligibility,
  getUserRewardBalance
};

export default OrderService;
